import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import ibotsLogo from '../../assets/ibots-logo.png';
import PaymentModal from '../../components/PaymentModal/PaymentModal';

const API = 'http://localhost:5000';

const CAT = {
  'Centre Training':  { badge:{ background:'#dbeafe', color:'#1e40af' }, border:'#3b82f6' },
  'Campus Programme': { badge:{ background:'#dcfce7', color:'#166534' }, border:'#22c55e' },
  'Demo Session':     { badge:{ background:'#ede9fe', color:'#5b21b6' }, border:'#8b5cf6' },
};

var COURSE_MONTHS = {
  'little innovator 1': 4, 'little innovator 2': 4,
  'junior innovator': 3,   'senior innovator': 6,
  'school-student': 3,     'college-student': 3,
  'workshop': 1,           'fdp': 1,
  'vac': 2,                'orientation-session': 1,
};

function getCourseMonths(r) {
  var key = (r.course || r.formType || '').toLowerCase().trim();
  return COURSE_MONTHS[key] || 3;
}

const fmt    = d => d ? new Date(d).toLocaleDateString('en-IN',{ day:'2-digit', month:'short', year:'numeric' }) : '—';
const fmtAgo = d => {
  if (!d) return '';
  var diff = Date.now() - new Date(d).getTime();
  var mins = Math.floor(diff/60000);
  if (mins < 1)  return 'just now';
  if (mins < 60) return mins + 'm ago';
  var hrs = Math.floor(mins/60);
  if (hrs < 24)  return hrs + 'h ago';
  var days = Math.floor(hrs/24);
  if (days < 7)  return days + 'd ago';
  return fmt(d);
};

function addMonths(date, n) { var d = new Date(date); d.setMonth(d.getMonth() + n); return d; }
function daysUntil(date) { return Math.ceil((new Date(date) - Date.now()) / 86400000); }

function getScheduleDates(startDate, type, n) {
  var dates = []; var d = startDate ? new Date(startDate) : new Date(); var checked = 0;
  if (!startDate) d.setDate(d.getDate() + 1); else d.setDate(d.getDate());
  while (dates.length < n && checked < 365) {
    var day = d.getDay();
    if (type === 'Weekend' && (day === 0 || day === 6)) dates.push(new Date(d));
    if (type === 'Weekday' && day >= 1 && day <= 5)    dates.push(new Date(d));
    d.setDate(d.getDate() + 1); checked++;
  }
  return dates;
}

function getAvailableDates(type, n) {
  var dates = []; var d = new Date(); d.setDate(d.getDate() + 1); var checked = 0;
  while (dates.length < n && checked < 60) {
    var day = d.getDay();
    if (type === 'Weekend' && (day === 0 || day === 6)) dates.push(new Date(d));
    if (type === 'Weekday' && day >= 1 && day <= 5)    dates.push(new Date(d));
    d.setDate(d.getDate() + 1); checked++;
  }
  return dates;
}

function getSampleMaterials(course) {
  var name = course || 'Course';
  return [
    { type:'PDF',   title:'Introduction to ' + name,       size:'2.4 MB' },
    { type:'VIDEO', title:'Chapter 1 — Fundamentals',       size:'45 min' },
    { type:'VIDEO', title:'Chapter 2 — Hands-on Practice',  size:'38 min' },
    { type:'PDF',   title:'Reference Guide & Cheat Sheet',  size:'1.1 MB' },
    { type:'QUIZ',  title:'Module Assessment Quiz',         size:'10 Q'   },
    { type:'ZIP',   title:'Project Files & Code Samples',   size:'8.6 MB' },
  ];
}

/* ── Mobile hook ── */
function useIsMobile() {
  var [m, setM] = useState(window.innerWidth < 768);
  useEffect(function() {
    function h() { setM(window.innerWidth < 768); }
    window.addEventListener('resize', h);
    return function(){ window.removeEventListener('resize', h); };
  }, []);
  return m;
}

/* ── Notification Bell ── */
function NotificationBell({ regs }) {
  var [open, setOpen] = useState(false);
  var ref = useRef(null);
  var isMobile = useIsMobile();
  var sevenDaysAgo = Date.now() - 7 * 24 * 60 * 60 * 1000;
  var notifications = [];
  regs.filter(function(r){ return !r.isPaid; }).forEach(function(r) {
    notifications.push({ type:'payment', title:'Payment Pending',
      message:'Complete payment for ' + (r.course || r.formType || 'your programme') + ' to unlock materials.',
      time: r.createdAt, eid: r.eid });
  });
  regs.filter(function(r){ return r.isPaid && r.paidAt; }).forEach(function(r) {
    var months = getCourseMonths(r); var paidDate = new Date(r.paidAt);
    for (var m = 1; m < months; m++) {
      var dueDate = addMonths(paidDate, m); var daysLeft = daysUntil(dueDate);
      if (daysLeft >= 0 && daysLeft <= 7) {
        notifications.push({ type:'installment', title:'Monthly Payment Due',
          message:(r.course || r.formType || 'Course') + ' — Month ' + (m+1) + ' due ' + fmt(dueDate),
          time: dueDate, eid: r.eid });
      }
    }
  });
  regs.filter(function(r){ return new Date(r.createdAt).getTime() > sevenDaysAgo; }).forEach(function(r) {
    notifications.push({ type:'enrolment', title:'New Enrolment',
      message:'You enrolled in ' + (r.course || r.formType || 'a programme') + '!',
      time: r.createdAt, eid: r.eid });
  });
  notifications.sort(function(a,b){ return new Date(b.time) - new Date(a.time); });
  var count = notifications.length;
  useEffect(function() {
    function h(e) { if (ref.current && !ref.current.contains(e.target)) setOpen(false); }
    document.addEventListener('mousedown', h);
    return function(){ document.removeEventListener('mousedown', h); };
  }, []);

  return (
    <div ref={ref} style={{ position:'relative' }}>
      <button onClick={function(){ setOpen(function(o){ return !o; }); }}
        style={{ position:'relative', display:'flex', alignItems:'center', justifyContent:'center', width:38, height:38, borderRadius:8, background:'rgba(255,255,255,0.1)', border:'1px solid rgba(255,255,255,0.2)', cursor:'pointer' }}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.85)" strokeWidth="2">
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/>
        </svg>
        {count > 0 && <span style={{ position:'absolute', top:-4, right:-4, background:'#ef4444', color:'#fff', fontSize:9, fontWeight:900, borderRadius:20, minWidth:16, height:16, display:'flex', alignItems:'center', justifyContent:'center', padding:'0 4px', border:'2px solid #0d2e6e' }}>{count > 9 ? '9+' : count}</span>}
      </button>
      {open && (
        <div style={{
          position:'fixed',
          /* On mobile: pin to top bar area and stretch edge-to-edge with a small margin.
             On desktop: keep the original anchored-to-button behaviour. */
          ...(isMobile
            ? { top:58, left:8, right:8, width:'auto' }
            : { position:'absolute', top:'calc(100% + 10px)', right:0, width:320 }),
          background:'#fff', borderRadius:14, boxShadow:'0 16px 48px rgba(5,15,50,0.22)', border:'1px solid #e2e8f0', zIndex:9999, overflow:'hidden' }}>
          <div style={{ padding:'14px 18px 10px', borderBottom:'1px solid #f1f5f9', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
            <div style={{ fontSize:13.5, fontWeight:900, color:'#0d2e6e' }}>Notifications</div>
            {count > 0 && <span style={{ fontSize:11, fontWeight:700, background:'#eff6ff', color:'#2563eb', borderRadius:20, padding:'2px 9px' }}>{count} new</span>}
          </div>
          <div style={{ maxHeight:360, overflowY:'auto' }}>
            {notifications.length === 0
              ? <div style={{ padding:'28px 18px', textAlign:'center', color:'#94a3b8', fontSize:13 }}>No notifications.</div>
              : notifications.map(function(n, i) {
                var isPay = n.type === 'payment'; var isInst = n.type === 'installment';
                var iconColor = isPay ? '#d97706' : isInst ? '#dc2626' : '#2563eb';
                var iconBg    = isPay ? '#fef3c7' : isInst ? '#fee2e2' : '#eff6ff';
                return (
                  <div key={i} style={{ padding:'12px 16px', borderBottom:'1px solid #f8fafc', display:'flex', alignItems:'flex-start', gap:10 }}>
                    <div style={{ width:32, height:32, borderRadius:8, background:iconBg, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={iconColor} strokeWidth="2">
                        {isPay || isInst ? <><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></> : <><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></>}
                      </svg>
                    </div>
                    <div style={{ flex:1, minWidth:0 }}>
                      <div style={{ fontSize:12, fontWeight:800, color:'#0d2e6e', marginBottom:2 }}>{n.title}</div>
                      {/* word-break prevents long course names from overflowing the panel */}
                      <div style={{ fontSize:11.5, color:'#475569', lineHeight:1.5, marginBottom:3, wordBreak:'break-word' }}>{n.message}</div>
                      <span style={{ fontSize:11, color:'#94a3b8' }}>{fmtAgo(n.time)}</span>
                    </div>
                  </div>
                );
              })}
          </div>
          {notifications.length > 0 && (
            <div style={{ padding:'10px 18px', borderTop:'1px solid #f1f5f9', textAlign:'center' }}>
              <span style={{ fontSize:12, fontWeight:700, color:'#2563eb', cursor:'pointer' }} onClick={function(){ setOpen(false); }}>Close</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

/* ── Course Detail Modal ── */
function CourseDetail({ r, onClose, onPay, paying }) {
  var isMobile = useIsMobile();
  var [scheduleType,  setScheduleType]  = useState('Weekend');
  var [selectedStart, setSelectedStart] = useState(null);
  var cat = CAT[r.category] || { badge:{ background:'#f1f5f9', color:'#475569' }, border:'#cbd5e1' };
  var trainer    = r.assigned || r.assignedPR || r.trainer || null;
  var months     = getCourseMonths(r);
  var availDates = getAvailableDates(scheduleType, 8);
  var sessions   = selectedStart ? getScheduleDates(selectedStart, scheduleType, months * 4) : [];
  var paySchedule = [];
  if (r.isPaid && r.paidAt) {
    for (var m = 0; m < months; m++) { paySchedule.push({ month: m+1, date: addMonths(new Date(r.paidAt), m), paid: m === 0 }); }
  }

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(5,15,40,0.6)', backdropFilter:'blur(6px)', zIndex:9999, display:'flex', alignItems: isMobile ? 'flex-end' : 'center', justifyContent:'center', padding: isMobile ? 0 : 16, fontFamily:"'Nunito','Segoe UI',sans-serif" }}
      onClick={function(e){ e.target===e.currentTarget&&onClose(); }}>
      <div style={{ background:'#fff', borderRadius: isMobile ? '18px 18px 0 0' : 18, width:'100%', maxWidth: isMobile ? '100%' : 700, maxHeight: isMobile ? '92vh' : '90vh', overflow:'hidden', display:'flex', flexDirection:'column', boxShadow:'0 32px 80px rgba(5,15,50,0.25)' }}>

        <div style={{ background:'linear-gradient(135deg,#0d2e6e,#2563eb)', padding: isMobile ? '16px 14px' : '22px 26px', flexShrink:0 }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
            <div style={{ flex:1, minWidth:0, paddingRight:8 }}>
              {/* minWidth:0 + paddingRight prevent the title pushing the close button off-screen */}
              <div style={{ fontSize: isMobile ? 14 : 18, fontWeight:900, color:'#fff', marginBottom:7, wordBreak:'break-word', lineHeight:1.35 }}>{r.course || r.formType || r.domain || 'Programme'}</div>
              <div style={{ display:'flex', alignItems:'center', gap:5, flexWrap:'wrap' }}>
                <span style={{ ...cat.badge, fontSize:10, fontWeight:700, padding:'3px 9px', borderRadius:20 }}>{r.category}</span>
                {r.isPaid ? <span style={{ background:'#dcfce7', color:'#166534', fontSize:10, fontWeight:800, padding:'3px 9px', borderRadius:20 }}>✓ Paid</span>
                          : <span style={{ background:'#fef3c7', color:'#92400e', fontSize:10, fontWeight:700, padding:'3px 9px', borderRadius:20 }}>⏳ Pending</span>}
                {r.eid && <span style={{ background:'rgba(255,255,255,0.15)', color:'rgba(255,255,255,0.9)', fontSize:10, fontWeight:700, padding:'3px 9px', borderRadius:20 }}>{r.eid}</span>}
              </div>
            </div>
            <button onClick={onClose} style={{ width:30, height:30, borderRadius:'50%', border:'1.5px solid rgba(255,255,255,0.25)', background:'rgba(255,255,255,0.1)', color:'#fff', fontSize:14, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>✕</button>
          </div>
        </div>

        <div style={{ overflowY:'auto', flex:1 }}>
          {!r.isPaid && (
            <div style={{ margin: isMobile ? '14px 14px 0' : '20px 26px 0', background:'#fffbeb', border:'1.5px solid #fde68a', borderRadius:12, padding: isMobile ? '12px 14px' : '18px 22px' }}>
              <div style={{ fontSize:13, fontWeight:800, color:'#92400e', marginBottom:6 }}>⚠️ Payment Required</div>
              <div style={{ fontSize:13, color:'#78350f', marginBottom:14, lineHeight:1.6 }}>Complete your payment to unlock course materials and get your trainer assigned.</div>
              <button onClick={function(){ onPay(r.eid); }} disabled={paying===r.eid}
                style={{ padding:'10px 24px', background:'linear-gradient(135deg,#d97706,#b45309)', border:'none', borderRadius:9, color:'#fff', fontSize:13, fontWeight:800, cursor:'pointer', fontFamily:"'Nunito','Segoe UI',sans-serif", opacity:paying===r.eid?0.7:1, width: isMobile ? '100%' : 'auto' }}>
                {paying===r.eid ? 'Processing...' : 'Proceed to Payment →'}
              </button>
            </div>
          )}

          {r.isPaid && (
            <div style={{ margin: isMobile ? '14px 14px 0' : '20px 26px 0', background:'#f0fdf4', border:'1.5px solid #bbf7d0', borderRadius:12, padding: isMobile ? '12px 14px' : '18px 22px' }}>
              <div style={{ fontSize:11, fontWeight:800, color:'#166534', textTransform:'uppercase', letterSpacing:'0.8px', marginBottom:10 }}>Your Assigned Trainer</div>
              {trainer ? (
                <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                  <div style={{ width:40, height:40, borderRadius:'50%', background:'linear-gradient(135deg,#0d2e6e,#2563eb)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:17, fontWeight:900, color:'#fff', flexShrink:0 }}>{trainer.charAt(0).toUpperCase()}</div>
                  <div>
                    <div style={{ fontSize:15, fontWeight:900, color:'#0d2e6e' }}>{trainer}</div>
                    <div style={{ fontSize:12, color:'#64748b' }}>iBots Certified Trainer</div>
                  </div>
                </div>
              ) : <div style={{ fontSize:13, color:'#475569' }}>Your trainer will be assigned shortly.</div>}
            </div>
          )}

          {r.isPaid && (
            <div style={{ margin: isMobile ? '14px 14px 0' : '16px 26px 0' }}>
              <div style={{ fontSize:13, fontWeight:800, color:'#0d2e6e', marginBottom:10, display:'flex', alignItems:'center', gap:8 }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                Schedule Your Classes
              </div>
              <div style={{ display:'flex', gap:8, marginBottom:12, flexWrap:'wrap' }}>
                {['Weekday','Weekend'].map(function(opt) {
                  return <button key={opt} onClick={function(){ setScheduleType(opt); setSelectedStart(null); }}
                    style={{ padding:'6px 16px', borderRadius:20, border:'1.5px solid', fontSize:12, fontWeight:700, cursor:'pointer',
                      borderColor: scheduleType===opt ? '#2563eb' : '#e2e8f0', background: scheduleType===opt ? '#eff6ff' : '#fff', color: scheduleType===opt ? '#2563eb' : '#64748b' }}>{opt}</button>;
                })}
                {selectedStart && <span style={{ fontSize:11, fontWeight:700, color:'#22c55e', background:'#f0fdf4', borderRadius:20, padding:'4px 10px', border:'1px solid #bbf7d0' }}>✓ {fmt(selectedStart)}</span>}
              </div>
              {/* On very small screens (≤360px) 4 cols can be tight; using minmax so they never overflow */}
              <div style={{ display:'grid', gridTemplateColumns: isMobile ? 'repeat(4,minmax(0,1fr))' : 'repeat(4,1fr)', gap: isMobile ? 5 : 8, marginBottom:14 }}>
                {availDates.map(function(d, i) {
                  var isSelected = selectedStart && d.toDateString() === new Date(selectedStart).toDateString();
                  return <button key={i} onClick={function(){ setSelectedStart(d); }}
                    style={{ background:isSelected?'#2563eb':i===0?'#eff6ff':'#f8fafc', border:isSelected?'2px solid #1d4ed8':i===0?'1.5px solid #93c5fd':'1.5px solid #e2e8f0', borderRadius:9, padding: isMobile ? '7px 2px' : '10px 6px', textAlign:'center', cursor:'pointer', minWidth:0 }}>
                    <div style={{ fontSize: isMobile ? 8 : 9, fontWeight:700, color:isSelected?'#fff':i===0?'#2563eb':'#94a3b8', textTransform:'uppercase', marginBottom:2 }}>{d.toLocaleString('en-IN',{weekday:'short'}).toUpperCase()}</div>
                    <div style={{ fontSize: isMobile ? 13 : 16, fontWeight:900, color:isSelected?'#fff':i===0?'#0d2e6e':'#334155' }}>{d.getDate()}</div>
                    <div style={{ fontSize: isMobile ? 8 : 9, color:isSelected?'rgba(255,255,255,0.8)':'#64748b', fontWeight:600 }}>{d.toLocaleString('en-IN',{month:'short'})}</div>
                  </button>;
                })}
              </div>
              {selectedStart && sessions.length > 0 && (
                <div style={{ background:'#f8fafc', borderRadius:10, padding:'12px 14px' }}>
                  <div style={{ fontSize:12, fontWeight:800, color:'#0d2e6e', marginBottom:8 }}>📋 {months}-month schedule ({sessions.length} sessions):</div>
                  <div style={{ display:'grid', gridTemplateColumns: isMobile ? 'repeat(2,1fr)' : 'repeat(auto-fill,minmax(110px,1fr))', gap:6 }}>
                    {sessions.slice(0, isMobile ? 8 : 16).map(function(d, i) {
                      return <div key={i} style={{ background:i===0?'#eff6ff':'#fff', border:i===0?'1px solid #93c5fd':'1px solid #e2e8f0', borderRadius:7, padding:'6px 8px', textAlign:'center' }}>
                        <div style={{ fontSize:9, fontWeight:700, color:'#94a3b8', textTransform:'uppercase' }}>Session {i+1}</div>
                        <div style={{ fontSize:11, fontWeight:900, color:'#0d2e6e' }}>{fmt(d)}</div>
                      </div>;
                    })}
                    {sessions.length > (isMobile ? 8 : 16) && <div style={{ background:'#f1f5f9', borderRadius:7, padding:'6px 8px', textAlign:'center', display:'flex', alignItems:'center', justifyContent:'center' }}><span style={{ fontSize:11, color:'#64748b', fontWeight:700 }}>+{sessions.length-(isMobile?8:16)} more</span></div>}
                  </div>
                </div>
              )}
            </div>
          )}

          {r.isPaid && paySchedule.length > 0 && (
            <div style={{ margin: isMobile ? '14px 14px 0' : '16px 26px 0' }}>
              <div style={{ fontSize:13, fontWeight:800, color:'#0d2e6e', marginBottom:10, display:'flex', alignItems:'center', gap:8 }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>
                Payment Schedule ({months} months)
              </div>
              <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
                {paySchedule.map(function(p) {
                  var due = daysUntil(p.date); var isDue = !p.paid && due >= 0 && due <= 7; var isPast = !p.paid && due < 0;
                  return <div key={p.month} style={{ display:'flex', alignItems:'center', gap:10, padding:'10px 12px',
                    background: p.paid ? '#f0fdf4' : isDue ? '#fffbeb' : isPast ? '#fff5f5' : '#f8fafc',
                    border: '1px solid ' + (p.paid ? '#bbf7d0' : isDue ? '#fde68a' : isPast ? '#fecaca' : '#e2e8f0'), borderRadius:10 }}>
                    <div style={{ width:30, height:30, borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', fontSize:12, fontWeight:900, flexShrink:0, background: p.paid ? '#22c55e' : isDue ? '#f59e0b' : isPast ? '#ef4444' : '#94a3b8', color:'#fff' }}>{p.month}</div>
                    <div style={{ flex:1, minWidth:0 }}>
                      <div style={{ fontSize:12, fontWeight:800, color:'#0f172a' }}>Month {p.month}</div>
                      <div style={{ fontSize:11, color:'#64748b' }}>{fmt(p.date)}</div>
                    </div>
                    <span style={{ fontSize:10.5, fontWeight:700, padding:'3px 9px', borderRadius:20, flexShrink:0,
                      background: p.paid ? '#dcfce7' : isDue ? '#fef3c7' : isPast ? '#fee2e2' : '#f1f5f9',
                      color: p.paid ? '#166534' : isDue ? '#92400e' : isPast ? '#991b1b' : '#475569' }}>
                      {p.paid ? '✓ Paid' : isDue ? '⚠ Due' : isPast ? 'Overdue' : 'Upcoming'}
                    </span>
                  </div>;
                })}
              </div>
            </div>
          )}

          <div style={{ margin: isMobile ? '14px 14px 20px' : '16px 26px 24px' }}>
            <div style={{ fontSize:13, fontWeight:800, color:'#0d2e6e', marginBottom:11, display:'flex', alignItems:'center', gap:8 }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>
              Course Materials
              {!r.isPaid && <span style={{ fontSize:10, fontWeight:700, background:'#fee2e2', color:'#dc2626', borderRadius:20, padding:'2px 8px' }}>LOCKED</span>}
            </div>
            <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
              {getSampleMaterials(r.course||r.formType).map(function(m, i) {
                var tc = { PDF:{bg:'#eff6ff',col:'#1e40af'}, VIDEO:{bg:'#f0fdf4',col:'#166534'}, QUIZ:{bg:'#fef3c7',col:'#92400e'}, ZIP:{bg:'#fdf4ff',col:'#7e22ce'} }[m.type] || {bg:'#f1f5f9',col:'#475569'};
                return <div key={i} style={{ display:'flex', alignItems:'center', gap:10, padding:'10px 12px', background:r.isPaid?'#fff':'#f8fafc', border:'1px solid #e2e8f0', borderRadius:10, opacity:r.isPaid?1:0.6 }}>
                  <span style={{ background:tc.bg, color:tc.col, fontSize:9, fontWeight:800, padding:'2px 6px', borderRadius:5, flexShrink:0 }}>{m.type}</span>
                  <div style={{ flex:1, minWidth:0 }}>
                    {/* minWidth:0 lets long titles truncate instead of stretching the row */}
                    <div style={{ fontSize:12.5, fontWeight:700, color:r.isPaid?'#0f172a':'#94a3b8', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>{m.title}</div>
                    <div style={{ fontSize:11, color:'#94a3b8' }}>{m.size}</div>
                  </div>
                  {r.isPaid ? <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2" style={{ flexShrink:0 }}><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                    : <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2" style={{ flexShrink:0 }}><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>}
                </div>;
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ── Course Card ── */
function CourseCard({ r, onClick }) {
  var cat = CAT[r.category] || { badge:{ background:'#f1f5f9', color:'#475569' }, border:'#cbd5e1' };
  return (
    <div onClick={onClick} style={{ background:'#fff', borderRadius:12, padding:'16px 18px', borderLeft:'4px solid '+cat.border, marginBottom:10, boxShadow:'0 1px 4px rgba(15,23,42,0.07)', cursor:'pointer' }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:8, marginBottom:8 }}>
        <div style={{ fontSize:15, fontWeight:900, color:'#0f172a', lineHeight:1.3, flex:1, minWidth:0, wordBreak:'break-word' }}>
          {r.course || r.formType || r.domain || r.programme || 'Programme'}
        </div>
        {/* Badges stack vertically on very narrow cards so they never overflow */}
        <div style={{ display:'flex', flexDirection:'column', gap:4, flexShrink:0, alignItems:'flex-end' }}>
          {r.isPaid
            ? <span style={{ fontSize:10, fontWeight:700, padding:'2px 8px', borderRadius:20, background:'#dcfce7', color:'#166534', whiteSpace:'nowrap' }}>✓ Paid</span>
            : <span style={{ fontSize:10, fontWeight:700, padding:'2px 8px', borderRadius:20, background:'#fef3c7', color:'#92400e', whiteSpace:'nowrap' }}>Pending</span>}
          <span style={{ ...cat.badge, fontSize:10, fontWeight:700, padding:'2px 8px', borderRadius:20, whiteSpace:'nowrap' }}>{r.category}</span>
        </div>
      </div>
      <div style={{ display:'flex', flexWrap:'wrap', gap:8, marginBottom:10 }}>
        {r.institution && <span style={{ fontSize:11.5, color:'#64748b' }}>🏫 {r.institution}</span>}
        <span style={{ fontSize:11.5, color:'#64748b' }}>📅 {fmt(r.createdAt)}</span>
        {r.eid && <span style={{ fontSize:10.5, fontWeight:800, color:cat.border, background:cat.badge.background, borderRadius:6, padding:'2px 6px' }}>{r.eid}</span>}
      </div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
        <span style={{ fontSize:11, fontWeight:700, padding:'3px 10px', borderRadius:20, background:'#fef9c3', color:'#854d0e' }}>Pending Review</span>
        <span style={{ fontSize:12, color:'#2563eb', fontWeight:700, whiteSpace:'nowrap' }}>View Details →</span>
      </div>
    </div>
  );
}

function NavIcon({ k, on }) {
  var c = on?'#2563eb':'#94a3b8';
  var p = { width:16, height:16, viewBox:'0 0 24 24', fill:'none', stroke:c, strokeWidth:'2' };
  if (k==='dashboard')    return <svg {...p}><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/></svg>;
  if (k==='courses')      return <svg {...p}><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>;
  if (k==='certificates') return <svg {...p}><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11"/></svg>;
  if (k==='profile')      return <svg {...p}><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>;
  return null;
}

const NAV = [
  { k:'dashboard',    t:'Dashboard'    },
  { k:'courses',      t:'My Courses'   },
  { k:'certificates', t:'Certificates' },
  { k:'profile',      t:'Profile'      },
];

export default function UserDashboard() {
  const navigate  = useNavigate();
  const isMobile  = useIsMobile();
  const [tab,      setTab]      = useState('dashboard');
  const [regs,     setRegs]     = useState([]);
  const [busy,     setBusy]     = useState(true);
  const [selected, setSelected] = useState(null);
  const [paying,   setPaying]   = useState(null);
  const [payModal, setPayModal] = useState(null);
  const user  = JSON.parse(localStorage.getItem('ibots_user') || '{}');
  const token = localStorage.getItem('ibots_user_token');

  const fetchRegs = useCallback(function() {
    setBusy(true);
    fetch(API + '/api/users/my-registrations', { headers: { Authorization: 'Bearer ' + token } })
      .then(r => r.json()).then(function(d){ setRegs(Array.isArray(d)?d:[]); setBusy(false); })
      .catch(function(){ setBusy(false); });
  }, [token]);

  useEffect(function() {
    if (!localStorage.getItem('ibots_user')) { navigate('/'); return; }
    fetchRegs();
  }, [navigate, fetchRegs]);

  const handlePay = function(eid) {
    var reg = regs.find(function(r){ return r.eid === eid; });
    setPayModal(reg);
  };

  const handleConfirmPay = async function(eid, utr) {
    setPaying(eid);
    try {
      await fetch(API + '/api/users/pay/' + eid, { method:'POST', headers:{ Authorization:'Bearer '+token, 'Content-Type':'application/json' }, body: JSON.stringify({ utr: utr }) });
      setPayModal(null); fetchRegs();
      if (selected) setSelected(function(p){ return Object.assign({}, p, { isPaid:true }); });
    } catch(e){ console.error(e); }
    finally { setPaying(null); }
  };

  const logout = function() {
    if (window.confirm('Are you sure you want to logout?')) {
      localStorage.removeItem('ibots_user_token'); localStorage.removeItem('ibots_user');
      window.dispatchEvent(new Event('ibots_user_updated')); navigate('/');
    }
  };

  var L      = (user.name||'S').charAt(0).toUpperCase();
  var tot    = regs.length;
  var cen    = regs.filter(r=>r.category==='Centre Training').length;
  var cam    = regs.filter(r=>r.category==='Campus Programme').length;
  var dem    = regs.filter(r=>r.category==='Demo Session').length;
  var unpaid = regs.filter(r=>!r.isPaid).length;
  var hour   = new Date().getHours();
  var greet  = hour<12?'Good morning':hour<17?'Good afternoon':'Good evening';

  var cp = isMobile ? '16px 14px' : '32px 36px';

  function Empty({ msg, sub }) {
    return (
      <div style={{ background:'#fff', borderRadius:12, padding:'40px 24px', textAlign:'center', boxShadow:'0 1px 4px rgba(15,23,42,0.07)' }}>
        <div style={{ fontSize:15, fontWeight:900, color:'#334155', marginBottom:8 }}>{msg}</div>
        <div style={{ fontSize:13, color:'#94a3b8', lineHeight:1.75, maxWidth:320, margin:'0 auto' }}>{sub}</div>
      </div>
    );
  }

  var Page = function() {
    if (tab==='dashboard') return (
      <div style={{ padding: cp }}>
        {/* Welcome banner */}
        <div style={{ background:'linear-gradient(135deg,#1e3a8a,#2563eb)', borderRadius:14, padding: isMobile ? '16px 14px' : '24px 30px', marginBottom:16, display:'flex', justifyContent:'space-between', alignItems:'center', boxShadow:'0 4px 20px rgba(37,99,235,0.22)', gap:10 }}>
          <div style={{ minWidth:0, flex:1 }}>
            <div style={{ fontSize:12, fontWeight:700, color:'rgba(255,255,255,0.6)', marginBottom:4 }}>{greet}</div>
            {/* Long names truncate gracefully instead of wrapping onto many lines */}
            <div style={{ fontSize: isMobile ? 18 : 25, fontWeight:900, color:'#fff', lineHeight:1.2, marginBottom:4, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>{user.name||'Student'}</div>
            <div style={{ fontSize:12, color:'rgba(255,255,255,0.6)' }}>Here is your learning overview.</div>
          </div>
          <div style={{ width:44, height:44, borderRadius:'50%', background:'rgba(255,255,255,0.15)', border:'2px solid rgba(255,255,255,0.25)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:18, fontWeight:900, color:'#fff', flexShrink:0 }}>{L}</div>
        </div>

        {/* Stats — 2 cols on mobile, 4 on desktop */}
        <div style={{ display:'grid', gridTemplateColumns: isMobile ? 'repeat(2,1fr)' : 'repeat(4,1fr)', gap: isMobile ? 10 : 16, marginBottom:18 }}>
          {[['Total Enrolled',tot,'#2563eb'],['Centre Training',cen,'#3b82f6'],['Campus Programmes',cam,'#22c55e'],['Demo Sessions',dem,'#8b5cf6']].map(function([l,v,c]) {
            return <div key={l} style={{ background:'#fff', borderRadius:12, padding: isMobile ? '14px 12px 11px' : '22px 20px 17px', borderTop:'3px solid '+c, boxShadow:'0 1px 4px rgba(15,23,42,0.07)', minWidth:0 }}>
              <div style={{ fontSize: isMobile ? 26 : 36, fontWeight:900, color:'#0f172a', lineHeight:1, marginBottom:5 }}>{v}</div>
              {/* hyphens:auto breaks very long label words on tiny screens */}
              <div style={{ fontSize: isMobile ? 10.5 : 12.5, fontWeight:700, color:'#94a3b8', lineHeight:1.4, wordBreak:'break-word', hyphens:'auto' }}>{l}</div>
            </div>;
          })}
        </div>

        {/* Breakdown */}
        {!isMobile && (
          <div style={{ background:'#fff', borderRadius:12, padding:'22px 26px', marginBottom:22, boxShadow:'0 1px 4px rgba(15,23,42,0.07)' }}>
            <div style={{ fontSize:14, fontWeight:900, color:'#0f172a', marginBottom:18 }}>Enrolment Breakdown</div>
            {tot===0 ? <div style={{ fontSize:13, color:'#94a3b8' }}>No enrolments yet.</div> :
              [['Centre Training',cen,'#2563eb'],['Campus Programmes',cam,'#22c55e'],['Demo Sessions',dem,'#8b5cf6']].map(function([l,v,c]) {
                return <div key={l} style={{ display:'flex', alignItems:'center', gap:13, marginBottom:13 }}>
                  <span style={{ width:148, fontSize:13, fontWeight:700, color:'#475569', flexShrink:0 }}>{l}</span>
                  <div style={{ flex:1, height:8, background:'#f1f5f9', borderRadius:99, overflow:'hidden' }}>
                    <div style={{ height:'100%', background:c, borderRadius:99, width:tot?(v/tot*100)+'%':'0%', transition:'width 1s' }}/>
                  </div>
                  <span style={{ width:35, textAlign:'right', fontSize:13, fontWeight:800, color:'#0f172a' }}>{tot?Math.round(v/tot*100):0}%</span>
                </div>;
              })}
          </div>
        )}

        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:12 }}>
          <div style={{ fontSize:14, fontWeight:900, color:'#0f172a' }}>Recent Registrations</div>
          <span style={{ fontSize:12, fontWeight:700, background:'#eff6ff', color:'#2563eb', borderRadius:20, padding:'3px 11px' }}>{tot} total</span>
        </div>
        {busy ? <div style={{ background:'#fff', borderRadius:12, padding:24, textAlign:'center', color:'#94a3b8', fontSize:13 }}>Loading...</div>
          : regs.length===0 ? <Empty msg="No Registrations Yet" sub="Enrol in a course and it will appear here." />
          : regs.slice(0,3).map(function(r,i){ return <CourseCard key={i} r={r} onClick={function(){ setSelected(r); }}/>; })}
      </div>
    );

    if (tab==='courses') return (
      <div style={{ padding: cp }}>
        <div style={{ fontSize: isMobile ? 20 : 24, fontWeight:900, color:'#0f172a', marginBottom:5 }}>My Courses</div>
        <div style={{ fontSize:13, color:'#94a3b8', marginBottom:18 }}>Tap any course to view details and manage payment.</div>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:12 }}>
          <div style={{ fontSize:14, fontWeight:900, color:'#0f172a' }}>All Registrations</div>
          <span style={{ fontSize:12, fontWeight:700, background:'#eff6ff', color:'#2563eb', borderRadius:20, padding:'3px 11px' }}>{tot} total</span>
        </div>
        {busy ? <div style={{ background:'#fff', borderRadius:12, padding:24, textAlign:'center', color:'#94a3b8', fontSize:13 }}>Loading...</div>
          : regs.length===0 ? <Empty msg="No Courses Yet" sub="Enrol in a course and it will appear here." />
          : regs.map(function(r,i){ return <CourseCard key={i} r={r} onClick={function(){ setSelected(r); }}/>; })}
      </div>
    );

    if (tab==='certificates') return (
      <div style={{ padding: cp }}>
        <div style={{ fontSize: isMobile ? 20 : 24, fontWeight:900, color:'#0f172a', marginBottom:5 }}>Certificates</div>
        <div style={{ fontSize:13, color:'#94a3b8', marginBottom:18 }}>Your earned certificates from completed courses.</div>
        <Empty msg="No Certificates Yet" sub="Complete your enrolled courses to earn certificates from iBots." />
      </div>
    );

    if (tab==='profile') return (
      <div style={{ padding: cp }}>
        <div style={{ fontSize: isMobile ? 20 : 24, fontWeight:900, color:'#0f172a', marginBottom:5 }}>My Profile</div>
        <div style={{ fontSize:13, color:'#94a3b8', marginBottom:18 }}>Your account details.</div>
        <div style={{ background:'#fff', borderRadius:14, padding: isMobile ? '18px 14px' : '30px 34px', boxShadow:'0 1px 4px rgba(15,23,42,0.07)' }}>
          <div style={{ display:'flex', alignItems:'center', gap:14, paddingBottom:18, borderBottom:'1px solid #f0f4f8', marginBottom:18 }}>
            <div style={{ width:50, height:50, borderRadius:'50%', background:'linear-gradient(135deg,#0d2e6e,#2563eb)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:22, fontWeight:900, color:'#fff', flexShrink:0 }}>{L}</div>
            <div style={{ minWidth:0 }}>
              <div style={{ fontSize:17, fontWeight:900, color:'#0f172a', marginBottom:3, wordBreak:'break-word' }}>{user.name||'—'}</div>
              <div style={{ fontSize:12, color:'#94a3b8' }}>iBots Student Account</div>
            </div>
          </div>
          {[['Name',user.name],['Email',user.email],['Phone',user.phone||'—'],['City',user.city||'—'],['Institution',user.institution||'—'],['Type',user.type,true]].map(function([l,v,badge],i,arr){
            return <div key={l} style={{ display:'flex', alignItems:'center', padding:'11px 0', borderBottom:i<arr.length-1?'1px solid #f0f4f8':'none', gap:8 }}>
              {/* Fixed label width reduced on mobile so the value column has room */}
              <div style={{ width: isMobile ? 76 : 128, fontSize:11, fontWeight:800, color:'#94a3b8', textTransform:'uppercase', letterSpacing:'0.5px', flexShrink:0 }}>{l}</div>
              {badge ? <span style={{ background:'#eff6ff', color:'#1e40af', borderRadius:20, padding:'3px 12px', fontSize:12, fontWeight:700 }}>{v||'—'}</span>
                     : <div style={{ fontSize:13, fontWeight:700, color:'#0f172a', wordBreak:'break-all', flex:1, minWidth:0 }}>{v||'—'}</div>}
            </div>;
          })}
        </div>
        {/* Logout button on profile page for mobile */}
        {isMobile && (
          <button onClick={logout} style={{ marginTop:16, width:'100%', padding:'13px', border:'1.5px solid #fecaca', borderRadius:10, background:'transparent', color:'#dc2626', fontSize:14, fontWeight:700, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:8, fontFamily:"'Nunito','Segoe UI',sans-serif" }}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
            Sign Out
          </button>
        )}
      </div>
    );
  };

  return (
    <div style={{ minHeight:'100vh', background:'#eef2f8', fontFamily:"'Nunito','Segoe UI',sans-serif", display:'flex', flexDirection:'column' }}>

      {/* Top bar */}
      <div style={{ height: isMobile ? 52 : 60, background:'linear-gradient(135deg,#020d1f,#0d2e6e)', display:'flex', alignItems:'center', justifyContent:'space-between', padding: isMobile ? '0 14px' : '0 28px', flexShrink:0, boxShadow:'0 2px 16px rgba(2,13,31,0.4)' }}>
        <img src={ibotsLogo} alt="iBots" style={{ height: isMobile ? 26 : 34, objectFit:'contain' }} />
        <div style={{ display:'flex', alignItems:'center', gap:8 }}>
          <NotificationBell regs={regs} />
          {!isMobile && (
            <button onClick={function(){ navigate('/'); }} style={{ display:'flex', alignItems:'center', gap:6, padding:'7px 16px', borderRadius:8, background:'rgba(255,255,255,0.08)', border:'1px solid rgba(255,255,255,0.18)', color:'rgba(255,255,255,0.9)', fontSize:12.5, fontWeight:700, cursor:'pointer', fontFamily:"'Nunito','Segoe UI',sans-serif" }}>
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/></svg>Back to Home
            </button>
          )}
          {isMobile && (
            <button onClick={function(){ navigate('/'); }} style={{ width:34, height:34, borderRadius:8, background:'rgba(255,255,255,0.08)', border:'1px solid rgba(255,255,255,0.18)', color:'rgba(255,255,255,0.9)', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' }}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/></svg>
            </button>
          )}
        </div>
      </div>

      <div style={{ display:'flex', flex:1, minHeight:0 }}>

        {/* Sidebar — desktop only */}
        {!isMobile && (
          <aside style={{ width:246, background:'#fff', borderRight:'1px solid #e2e8f0', display:'flex', flexDirection:'column', flexShrink:0, boxShadow:'2px 0 8px rgba(15,23,42,0.04)' }}>
            <div style={{ padding:'24px 20px 20px', background:'linear-gradient(160deg,#f8faff,#eef4ff)', borderBottom:'1px solid #e2ebff' }}>
              <div style={{ width:50, height:50, borderRadius:'50%', background:'linear-gradient(135deg,#0d2e6e,#2563eb)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:20, fontWeight:900, color:'#fff', marginBottom:12, boxShadow:'0 4px 12px rgba(37,99,235,0.28)' }}>{L}</div>
              <div style={{ fontSize:10.5, fontWeight:800, color:'#93a3c0', textTransform:'uppercase', letterSpacing:'1.2px', marginBottom:4 }}>Welcome back</div>
              <div style={{ fontSize:18, fontWeight:900, color:'#0d2e6e', marginBottom:3 }}>{user.name||'Student'}</div>
              <div style={{ fontSize:11.5, color:'#94a3b8', marginBottom:10, wordBreak:'break-all' }}>{user.email||''}</div>
              {user.type && <span style={{ background:'#dbeafe', color:'#1e40af', borderRadius:20, padding:'3px 11px', fontSize:11.5, fontWeight:700 }}>{user.type}</span>}
            </div>
            <div style={{ padding:'10px 0', flex:1 }}>
              <div style={{ fontSize:10, fontWeight:800, color:'#c8d3e6', textTransform:'uppercase', letterSpacing:'1.3px', padding:'6px 20px' }}>Menu</div>
              {NAV.map(function({ k, t }) {
                var on = tab===k;
                return <button key={k} onClick={function(){ setTab(k); }} style={{ display:'flex', alignItems:'center', justifyContent:'space-between', gap:10, padding:'11px 20px', width:'100%', textAlign:'left', border:'none', borderLeft:on?'3px solid #2563eb':'3px solid transparent', background:on?'linear-gradient(90deg,#eff6ff,#f8fbff)':'transparent', color:on?'#1d4ed8':'#64748b', fontSize:13.5, fontWeight:on?800:600, cursor:'pointer', fontFamily:"'Nunito','Segoe UI',sans-serif" }}>
                  <span style={{ display:'flex', alignItems:'center', gap:9 }}><NavIcon k={k} on={on}/>{t}</span>
                  {k==='courses' && unpaid>0 && <span style={{ background:'#ef4444', color:'#fff', fontSize:10, fontWeight:900, borderRadius:20, padding:'1px 7px' }}>{unpaid}</span>}
                </button>;
              })}
            </div>
            <button onClick={logout} style={{ margin:'0 15px 18px', padding:'10px', border:'1.5px solid #fecaca', borderRadius:10, background:'transparent', color:'#dc2626', fontSize:13, fontWeight:700, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:8, fontFamily:"'Nunito','Segoe UI',sans-serif" }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>Sign Out
            </button>
          </aside>
        )}

        {/* Main */}
        <main style={{ flex:1, overflowY:'auto', background:'#eef2f8', paddingBottom: isMobile ? 70 : 0 }}>
          <Page />
        </main>
      </div>

      {/* Bottom nav — mobile only */}
      {isMobile && (
        <nav style={{ position:'fixed', bottom:0, left:0, right:0, height:60, background:'#fff', borderTop:'1px solid #e2e8f0', display:'flex', alignItems:'center', zIndex:100, boxShadow:'0 -2px 12px rgba(15,23,42,0.08)' }}>
          {NAV.map(function({ k, t }) {
            var on = tab===k;
            return <button key={k} onClick={function(){ setTab(k); }} style={{ flex:1, height:'100%', border:'none', background:'transparent', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', gap:3, cursor:'pointer', fontFamily:"'Nunito','Segoe UI',sans-serif", position:'relative', padding:'0 2px', minWidth:0 }}>
              <NavIcon k={k} on={on}/>
              {/* overflow hidden so "Certificates" never wraps or overflows on 320px screens */}
              <span style={{ fontSize:9.5, fontWeight: on ? 800 : 600, color: on ? '#2563eb' : '#94a3b8', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis', width:'100%', textAlign:'center' }}>{t}</span>
              {k==='courses' && unpaid>0 && <span style={{ position:'absolute', top:8, right:'calc(50% - 14px)', background:'#ef4444', color:'#fff', fontSize:9, fontWeight:900, borderRadius:20, minWidth:14, height:14, display:'flex', alignItems:'center', justifyContent:'center', padding:'0 3px' }}>{unpaid}</span>}
            </button>;
          })}
        </nav>
      )}

      {selected && <CourseDetail r={selected} onClose={function(){ setSelected(null); }} onPay={handlePay} paying={paying}/>}
      {payModal && <PaymentModal r={payModal} onClose={function(){ setPayModal(null); }} onConfirm={handleConfirmPay} paying={paying} />}
    </div>
  );
}
